import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';

import AuthenticationDispatch from '../../contexts/authenticationDispatch';
import authenticationActions from '../../actions/authentication.actions';

import style from './NewUser.module.css';

const NewUser = React.memo(({ newUser = false }) => {
  const dispatch = useContext(AuthenticationDispatch);

  const onClose = () => {
    dispatch({
      type: authenticationActions.NEW_USER_SUCCESS,
    });
  };

  const closeIcon = (
    <g fill="none" fillRule="evenodd">
      <path
        fill="#231F20"
        d="M16 1.28C7.883 1.28 1.28 7.883 1.28 16S7.883 30.72 16 30.72 30.72 24.117 30.72 16 24.117 1.28 16 1.28zM16 32C7.177 32 0 24.823 0 16S7.177 0 16 0s16 7.177 16 16-7.177 16-16 16z"
      />
      <g fill="#000">
        <path d="M22.165 22.534a.63.63 0 0 1-.446-.185L9.809 10.44a.632.632 0 1 1 .893-.893l11.91 11.91a.632.632 0 0 1-.447 1.078" />
        <path d="M10.256 22.534a.633.633 0 0 1-.447-1.078l11.91-11.91a.632.632 0 1 1 .893.894l-11.91 11.91a.63.63 0 0 1-.446.184" />
      </g>
    </g>
  );

  return (
    <Modal
      center
      open={newUser}
      onClose={onClose}
      classNames={{ modal: style.modalContent }}
      styles={{ closeButton: { outline: 0, cursor: 'pointer' } }}
      closeIconSvgPath={closeIcon}
    >
      <div className={`modal-header ${style.header}`}>
        <span className={style.text}>New User</span>
      </div>
      <div className={`modal-body ${style.modalBody}`}>
        If you do not have an account, please contact the SMART Team SPG_smarthubservice@specialtyprogramgroup.com
      </div>
      <div className={`form-row d-flex flex-row-reverse ${style.row}`}>
        <button
          type="button"
          className={`btn btn-primary ${style.closeBtn}`}
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </Modal>
  );
});

NewUser.propTypes = {
  newUser: PropTypes.bool,
};

export default NewUser;
